import React from 'react';
import { Modal, Grid } from 'antd';

/**
 * Ant Design Modal with phone-friendly full-width sheet under 768px.
 * Bind to existing open/onCancel handlers — no business logic.
 */
const ResponsiveModal = ({
  open,
  onCancel,
  children,
  width = 640,
  title,
  ...rest
}) => {
  const screens = Grid.useBreakpoint();
  const isMobile = screens.md === false;

  return (
    <Modal
      open={!!open}
      onCancel={onCancel}
      footer={null}
      title={title}
      width={isMobile ? '100%' : width}
      centered={!isMobile}
      destroyOnClose={false}
      maskClosable={!rest.confirmLoading}
      style={
        isMobile
          ? { top: 8, margin: 0, maxWidth: '100vw', paddingBottom: 0 }
          : undefined
      }
      styles={{
        body: {
          maxHeight: isMobile ? '85vh' : '80vh',
          overflowY: 'auto',
          padding: isMobile ? 16 : 24,
        },
      }}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default ResponsiveModal;
